import React from 'react';
import {
  SimpleDataTable as DataTable
} from '../../../web.common';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../../common/withRouter';
import withApi from '../../higherOrderComponents/withApi';
import {
  DisplayGuid,
  DisplayStatus,
  DisplayPercentage
} from '../../items';
import { purchaseParticipantStatus } from '../../../enums/purchaseParticipantStatus';

const resultsCount = 15;

class ParticipantsInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  async loadData(skipPages) {
    const {
      props: {
        api: { purchases: { searchParticipants } },
        purchaseProductId
      }
    } = this;

    let result = null;

    try {
      result = await searchParticipants({
        filters: {
          purchaseProductId
        },
        skipPages,
        resultsCount
      }
      );
    }
    catch (e) {
      console.error(`unable to load. ${e}`);

      return;
    }

    return result;
  }

  render() {
    const {
      page
    } = this.state;
    const pageNumber = page || 1;

    const getData = async () => this.loadData(pageNumber || 1);

    return (
      <React.Fragment>
        <DataTable
          key={`purchase-fields-page-${page}`}
          style={{ marginTop: '100px' }}
          tableConfig={{
            tableName: 'participants',
            columns: [
              {
                property: 'Id',
                label: 'Id',
                render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
              },
              {
                property: 'InviteeName',
                label: 'Name'
              },
              {
                property: 'ParticipantsIndex',
                label: 'Participants Index'
              },
              {
                property: 'Reference',
                label: 'Reference'
              },
              {
                property: 'Type',
                label: 'Type'
              },
              {
                property: 'Status',
                label: 'Status',
                render: ({ Status }) =>
                  <DisplayStatus mapping={purchaseParticipantStatus}>{Status}</DisplayStatus>
              }
            ]
          }}
          getData={getData}
          paginationData={{
            renderLocation: 'bottom',
            rowsPerPage: resultsCount,
            pageNumber,
            goToPageNumber: number => {
              this.setState({
                page: number
              });
            }
          }}
          cellVerticalAlign='top'
          hideTableHead={false}
          languageCode='en'
          labels={{
            tableBody: {
              noResult: 'no results'
            }
          }}
          cellContent='cellContent'
        />
      </React.Fragment>
    );
  }
}

const Participants = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(ParticipantsInternal)
));
Participants.requiresLogin = true;
Participants.propTypes = { isLoggedIn: PropTypes.bool };

export default Participants;